import React, { useCallback } from 'react';
import Text from 'design-system/Text';
import { Button, CardView, rem, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import IconInvestTab from '../icons/IconInvestTab';
import { blockInvestActionOnWeb } from '../webGate';
const DepositCTA = () => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const handleDeposit = useCallback(() => {
        if (blockInvestActionOnWeb('Deposit'))
            return;
        navigation.navigate('InvestSelectAccountToTopup');
    }, [navigation]);
    return (<CardView style={styles.card} noMarginTop noMarginBottom>
      <IconInvestTab size={32} gradientColors={colors.gradients.ultimate.colors} notificationDot={false}/>
      <Spacer.H16 />
      <Text Text-14 Primary>
        Unlock trading
      </Text>
      <Spacer h={4}/>
      <Text Text-16 centered>
        {'Deposit in your account\nto start investing'}
      </Text>
      <Spacer.H16 />
      <Button small hug brand title="Deposit" onPress={handleDeposit} style={styles.button}/>
    </CardView>);
};
export default DepositCTA;
const styleSet = createStyleSheets(() => ({
    card: {
        marginTop: rem(8),
        alignItems: 'center',
        paddingVertical: rem(24),
    },
    button: {
        paddingHorizontal: rem(30),
    },
}));
